import React, { useRef, useEffect, useState } from "react";
import MeetingFooter from "../MeetingFooter/MeetingFooter.component";
import Participants from "../Participants/Participants.component";
import "./MainScreen.css";
import { connect } from "react-redux";
import { Offcanvas } from "react-bootstrap";
import { setMainStream, updateUser } from "../../store/actioncreator";
import moment from "moment";
import { useMeetingAppContext } from "../../../MeetingAppContextDef";

const MainScreen = (props) => {
  const { data } = props;
  const { loading } = props;
  const { event } = props;
  const { canvaStatus } = props;


  const event_date = moment(event.date).format("YYYY-MM-DD");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const participantRef = useRef(props.participants);

  const onMicClick = (micEnabled) => {
    if (props.stream) {
      props.stream.getAudioTracks()[0].enabled = micEnabled;
      props.updateUser({ audio: micEnabled });
    }
  };
  const onVideoClick = (videoEnabled) => {
    if (props.stream) {
      props.stream.getVideoTracks()[0].enabled = videoEnabled;
      props.updateUser({ video: videoEnabled });
    }
  };

  useEffect(() => {
    if (canvaStatus) {
      handleClose();
    }
    setShow(canvaStatus);
    participantRef.current = props.participants;



  }, [props.participants]);

  const updateStream = (stream) => {
    for (let key in participantRef.current) {
      const sender = participantRef.current[key];
      if (sender.currentUser) continue;
      const peerConnection = sender.peerConnection
        .getSenders()
        .find((s) => (s.track ? s.track.kind === "video" : false));
      peerConnection.replaceTrack(stream.getVideoTracks()[0]);
    }
    props.setMainStream(stream);
  };

  const onScreenShareEnd = async () => {
    const localStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });

    localStream.getVideoTracks()[0].enabled = Object.values(
      props.currentUser
    )[0].video;

    updateStream(localStream);

    props.updateUser({ screen: false });
  };

  const onScreenClick = async () => {
    let mediaStream;
    if (navigator.getDisplayMedia) {
      mediaStream = await navigator.getDisplayMedia({ video: true });
    } else if (navigator.mediaDevices.getDisplayMedia) {
      mediaStream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
      });
    } else {
      mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { mediaSource: "screen" },
      });
    }

    mediaStream.getVideoTracks()[0].onended = onScreenShareEnd;

    updateStream(mediaStream);

    props.updateUser({ screen: true });
  };

  const joinCall = (room_id) => {
    if (localStorage.getItem('auth_type') == 'admin') {

      window.location.href = `/superstar-admin/live-chat/stream/${event.slug}?id=${room_id}`;
    } else {
      window.location.href = `/superstar/live-chat/stream/${event.slug}?id=${room_id}`;
    }

  };

  return (
    <div className="wrapper">
      <div className="main-screen">
        <Participants />
      </div>

      <div className="footer">
        <MeetingFooter
          slug={event.slug}
          onScreenClick={onScreenClick}
          onMicClick={onMicClick}
          onVideoClick={onVideoClick}
          handleShow={handleShow}
        />
      </div>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch
      </Button> */}

      <Offcanvas placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title> All participants</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <tr>
              <th>Name</th>
              <th>Minute(s)</th>
              <th>Action</th>
            </tr>

            {loading ? (
              data.map((item) => {
                return (
                  <tr>
                    <td>
                      <span>
                        {" "}
                        {item.user?.first_name} {item.user?.last_name}
                      </span>
                    </td>

                    <td>
                      {(new Date(event_date + " " + item.live_chat_end_time) -
                        new Date(
                          event_date + " " + item.live_chat_start_time
                        )) /
                        60000}
                    </td>

                    <td>
                      <button
                        className="btn btn-sm btn-success px-3"
                        onClick={() => joinCall(item.room_id)}
                      >
                        <span>
                          <i className="fas fa-video"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <h3>laoding...</h3>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stream: state.mainStream,
    participants: state.participants,
    currentUser: state.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainStream: (stream) => dispatch(setMainStream(stream)),
    updateUser: (user) => dispatch(updateUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);
